// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  INTERVIEW_START_GRACE_MINUTES,
} from "@/legacy/helpersModule";
import { Modal } from "@/shared/components/ui/Modal";
import { Button, Input } from "@/shared/components/ui";
export function InterviewScheduleModal({ jobTitle, onConfirm, onCancel, busy = false }) {
  const [local, setLocal] = useState("");
  useEffect(() => {
    const d = new Date();
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    setLocal(d.toISOString().slice(0, 16));
  }, []);
  return (
    <Modal title={jobTitle ? `Schedule · ${jobTitle}` : "Schedule interview"} onClose={busy ? undefined : onCancel}>
      <Input type="datetime-local" value={local} onChange={e => setLocal(e.target.value)} className="mb-4" />
      <Button
        type="button"
        fullWidth
        loading={busy}
        disabled={busy || !local}
        onClick={() => { if (!local || busy) return; onConfirm(new Date(local).toISOString()); }}
        className="mb-3"
      >
        Confirm slot
      </Button>
      <Button type="button" variant="ghost" fullWidth disabled={busy} onClick={onCancel}>Cancel</Button>
    </Modal>
  );
}

